import CampaignRespodentPanel from './campaignRespondentPanel.container';

export default CampaignRespodentPanel;